import styled, { css } from 'styled-components';
import { Colors } from '../../../../ui';

export const AdfDefaultThemeCss = css`
    font-family: 'Rubik';
    line-height: 1.5;
    color: ${Colors.text};

    hr {
        border: none;
        height: 1px;
        background-color: ${Colors.border};
        margin: 1rem 0;
    }
    
    p {
        margin: 0.75rem 0;
        line-height: 1.6;
        cursor: text;
    }

    p:first-child {
        margin-top: 0;
    }

    p:last-child {
        margin-bottom: 0;
    }
    
    ul {
        cursor: text;
        margin: 1rem 0;
        padding-left: 1.5rem;
        list-style-type: disc;
        
        li {
            margin: 0.25rem 0;
            line-height: 1.5;
        }
    }
    
    ol {
        cursor: text;
        margin: 1rem 0;
        padding-left: 1.5rem;
        list-style-type: decimal;
        
        li {
            margin: 0.25rem 0;
            line-height: 1.5;
        }
    }
    
    code {
        cursor: text;
        background-color: #f1f2f4;
        padding: 0.125rem 0.25rem;
        border-radius: 0.25rem;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 0.875em;
    }
    
    a {
        cursor: pointer;
        color: #0052cc;
        text-decoration: underline;
        
        &:hover {
            text-decoration: none;
        }
    }
    
    strong {
        font-weight: 600;
    }
    
    em {
        font-style: italic;
    }
    
    u {
        text-decoration: underline;
    }
    
    s {
        text-decoration: line-through;
    }
    
    sub {
        vertical-align: sub;
        font-size: smaller;
    }
    
    sup {
        vertical-align: super;
        font-size: smaller;
    }
    
    blockquote {
        cursor: text;
        border-left: 4px solid ${Colors.border};
        padding-left: 1rem;
        margin: 1rem 0;
        color: ${Colors.text};
    }
    
    .panel {
        border-radius: 4px;
        padding: .5rem;
        margin: 1rem 0;
        
        &.info {
            background-color: #E3F2FD;
            border: 1px solid #2196F3;
        }
        
        &.note {
            background-color: #E8F5E8;
            border: 1px solid #4CAF50;
        }
        
        &.warning {
            background-color: #FFF3E0;
            border: 1px solid #FF9800;
        }
        
        &.error {
            background-color: #FFEBEE;
            border: 1px solid #F44336;
        }
        
        &.success {
            background-color: #E8F5E8;
            border: 1px solid #4CAF50;
        }
    }
    
    .block-card {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border: 1px solid ${Colors.border};
        border-radius: 0.25rem;
        padding: 0.125rem 0.25rem;
        margin: 0.5rem 0;
        width: fit-content;
    }
    
    .media-item {
        margin: 1rem 0;
        
        img {
            max-width: 100%;
            height: auto;
            border-radius: 0.25rem;
        }
    }
    
    .media-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        border: 2px dashed ${Colors.border};
        border-radius: 0.5rem;
        background-color: #f8f9fa;
        color: #6c757d;
        
        span {
            font-size: 1rem;
            margin-bottom: 0.5rem;
        }
        
        small {
            font-size: 0.75rem;
            opacity: 0.7;
        }
    }
    
    .media-link {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        border: 1px solid ${Colors.border};
        border-radius: 0.25rem;
        background-color: #f8f9fa;
        color: #0052cc;
        text-decoration: none;
        transition: background-color 0.2s;
        
        &:hover {
            background-color: #e9ecef;
        }
    }
    
    .code-block {
        margin: 1rem 0;
        
        pre {
            background-color: #f8f9fa;
            border: 1px solid ${Colors.border};
            border-radius: 0.25rem;
            padding: 1rem;
            overflow-x: auto;
            font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
            font-size: 0.875rem;
            line-height: 1.4;
            
            code {
                background: none;
                padding: 0;
                border-radius: 0;
                font-size: inherit;
            }
        }
    }
    
    .date {
        color: ${Colors.text};
        font-weight: 500;
    }
    
    .emoji {
        font-size: 1.1em;
        vertical-align: middle;
    }
    
    .expand {
        margin: 1rem 0;
        border: 1px solid ${Colors.border};
        border-radius: 0.25rem;
        
        summary {
            padding: 0.75rem;
            cursor: pointer;
            font-weight: 500;
            background-color: #f8f9fa;
            border-radius: 0.25rem;
            user-select: none;
            
            &:hover {
                background-color: #e9ecef;
            }
        }
        
        .expand-content {
            padding: 1rem;
            border-top: 1px solid ${Colors.border};
        }
    }
    
    h1, h2, h3, h4, h5, h6 {
        margin: 1.5rem 0 1rem 0;
        font-weight: 600;
        line-height: 1.3;
        
        &:first-child {
            margin-top: 0;
        }
    }
    
    h1 { font-size: 1.125rem; }
    h2 { font-size: 1.125rem; }
    h3 { font-size: 1.0rem; }
    h4 { font-size: 1.0rem; }
    h5 { font-size: .875rem; }
    h6 { font-size: .875rem; }
`;

export const AdfDefaultTheme = styled.div`
    ${AdfDefaultThemeCss}
`;
